import { useMount } from 'react-use';
import { redirectToAuth } from 'supertokens-auth-react';
import Session from 'supertokens-auth-react/recipe/session';

import { Alert, AlertTitle, LoadingIcon, Stack } from '@eluve/components';
import { clearSkippedInterstitials } from '@eluve/interstitials';
import { usePostHog } from '@eluve/posthog-react';

export interface LogoutPageProps {
  onBeforeLogout?: () => Promise<void>;
}

export const LogoutPage: React.FC<LogoutPageProps> = ({ onBeforeLogout }) => {
  const posthog = usePostHog();

  const handleLogout = async () => {
    clearSkippedInterstitials();
    posthog?.reset();
    if (onBeforeLogout) {
      try {
        await onBeforeLogout();
      } catch {
        // Optional app cleanup must never block the primary logout.
      }
    }
    await Session.signOut();
    await redirectToAuth({
      redirectBack: false,
    });
  };

  useMount(handleLogout);

  return (
    <Stack className="min-h-screen p-4" gap={2} align="center" justify="center">
      <Alert className="flex max-w-md items-center gap-2" variant="default">
        <div>
          <LoadingIcon size="xl" />
        </div>
        <AlertTitle>Signing out...</AlertTitle>
      </Alert>
    </Stack>
  );
};
